<script lang="ts" setup>
import SFButton from '@/components/ui/button/Button.vue'
import Checkbox from '@/components/ui/checkbox/Checkbox.vue'
import { inject, ref } from 'vue'
import { onClickOutside } from '@vueuse/core'
import { FireRiskDashboardViewModel } from '../viewmodels/FireRiskDashboard.viewmodel'
import { FireAlertsTableHeadersFactory } from '../factories/FireAlertsTableHeaders.factory'

const vm = inject<FireRiskDashboardViewModel>('fire-risk-dashboard-viewmodel')!

const selector = ref()

const isOpen = ref(false)

onClickOutside(selector, () => (isOpen.value = false))
</script>

<template>
	<div class="relative">
		<s-f-button
			class="h-full"
			icon="material-symbols:view-column"
			:title="$t('fireRiskDashboardVisibleColumns').toString()"
			secondary
			@click="isOpen = true"
		/>
		<!-- div (e não ul): o ContextMenu.vue zera globalmente o padding-left de
		`.v-application ul` com !important, o que colava o conteúdo na borda esquerda. -->
		<div
			ref="selector"
			v-show="isOpen"
			role="group"
			aria-labelledby="fire-alerts-columns-title"
			class="bg-white-neutral border border-black-neutral rounded min-w-max absolute z-10 p-3 flex flex-col gap-2 right-0 top-full mt-1"
		>
			<span
				id="fire-alerts-columns-title"
				class="text-label mb-1"
			>
				{{ $t('fireRiskDashboardOptionalColumns') }}
			</span>
			<checkbox
				v-for="column in FireAlertsTableHeadersFactory.OPTIONAL_COLUMNS"
				:key="column.key"
				:id="`fire-alerts-column-${column.key}`"
				class="items-center"
				:label="$t(column.labelKey).toString()"
				:model-value="column.key"
				v-model="vm.visibleOptionalAlertColumns.value"
			/>
		</div>
	</div>
</template>
